import React, {Component} from 'react';
import {Row, Col, FormControl} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAdd, TopButtonPointAction, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../../../utilities/Validator";
import ControlLabel from "react-bootstrap/es/ControlLabel";

export default class PojazdyEkipaCompontent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nowypojazd:null,
            nowazmiana:1,
        };
        this.renderItem = this.renderItem.bind(this)
        this.onClickZapiszZmiane = this.onClickZapiszZmiane.bind(this)
        this.onChangeNowyPojazd = this.onChangeNowyPojazd.bind(this)
        this.onChangeNowaZmiana = this.onChangeNowaZmiana.bind(this)
        this.onClickDodajNowy = this.onClickDodajNowy.bind(this)
    }

    onChangeNowyPojazd(e){
        this.setState({nowypojazd:e})
    }

    onChangeNowaZmiana(e){
        this.setState({nowazmiana:e.target.value})
    }

    onClickDodajNowy(){
        if(Boolean(this.state.nowazmiana) && Validator.validateInt(this.state.nowazmiana) && Boolean(this.state.nowypojazd)){
            let data = {
                "idEk": this.props.ekipa.idEk,
                "idPo": this.state.nowypojazd.idPo,
                "idTmSt": this.props.ekipa.idTmSt,
                "idEkSt": this.props.ekipa.idEkSt,
                "idPoSt": this.state.nowypojazd.idPoSt,
                "zmiana": this.state.nowazmiana
            }
            this.props.handleClickDodaj(data)
            this.setState({
                nowypojazd:null,
                nowazmiana:1,
            })
            document.getElementById('inputNowaZmianaPojazd').value = 1;
        }
        else{
            alert('Proszę uzupełnić wszystkie dane (wybór pojazdu oraz zmiany) przy dodawaniu nowego pojazdu')
        }
    }

    onClickZapiszZmiane(obj){

        let input = document.getElementById('ekp-'+obj.idEkp)
        if(Boolean(input)){
            if(Validator.validateInt(input.value)){
                let data = {
                    "idEkp":obj.idEkp,
                    "idEkSt": obj.idEkSt,
                    "idEk": obj.idEk,
                    "idPo": obj.idPo,
                    "idPoSt": obj.idPoSt,
                    "zmiana": input.value
                }

                this.props.handleClickEdytuj(data)
            }
            else{
                input.style.borderColor = 'firebrick'
                setTimeout(function () {
                    input.style.borderColor = '#ccc'
                },1500)
            }
        }
    }

    renderItem(item){
        let pojazd = this.props.pojazdy.find(k=>k.idPo===item.idPo)
        if(Boolean(pojazd)){
            return(<div>
                <Row style={{marginTop:'5px'}}>
                    <Col xs={12} lg={6}>
                        <ControlLabel style={{marginBottom:'0px', lineHeight:'34px'}}>{pojazd.marka+' '+pojazd.model+' '+pojazd.nrRej}
                            {Boolean(pojazd.wifi) ? <span style={{marginLeft:'3px', fontWeight:'normal', color:'grey'}} title={'wifi'}><i className={'fa fa-wifi'}></i> {pojazd.wifi}</span>:''}
                        </ControlLabel>
                    </Col>
                    <Col xs={6} lg={2}>
                        <FormControl type={'number'} defaultValue={Boolean(item.zmiana)? item.zmiana:''} bsSize={'xs'} id={'ekp-'+item.idEkp}/>
                    </Col>
                    <Col xs={6} lg={3}>
                        <TopButtonPointAction buttonIcon={'fa fa-save'} onClick={()=>{this.onClickZapiszZmiane(item)}} titleContent={'Zapisz numer zmiany'}/>
                        <TopButtonPointRemove onClick={()=>{this.props.handleClickUsun(item)}} titleContent={'Usuń pojazd z tej ekipy'}/>
                    </Col>
                </Row>
            </div>)
        }

    }

    renderPojazdSelect(option){
        return(
            <div>
                <span>{option.pojazdInfo}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status)?
                            <span style={{fontSize:'12px',color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                            :
                            <span style={{fontSize:'12px',color:'firebrick'}}><i className={'fa fa-times'}></i> niedostępny</span>

                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div style={{marginTop:'15px'}}>
                <h6 style={{color:'grey',fontSize:'16px'}}>
                    <i className={'fa fa-bus'}></i> Pojazdy
                </h6>
                <Row>
                    <Col xs={12}>
                        <Row style={{marginTop:'5px',marginBottom:'5px', color:'grey',fontStyle:'italic'}}>
                            <Col xs={12} lg={6}>
                                <div style={{borderBottom:'1px solid #ddd'}}>
                                    Pojazd
                                </div>
                            </Col>
                            <Col xs={6} lg={2}>
                                <div style={{borderBottom:'1px solid #ddd'}}>
                                    Zmiana
                                </div>
                            </Col>
                            <Col xs={6} lg={2}>
                                <div style={{borderBottom:'1px solid #ddd'}}>
                                    Akcje
                                </div>
                            </Col>
                        </Row>
                        {
                            this.props.pojazdyWEkipie.map(item=>{
                                return this.renderItem(item)
                            })}
                        <Row style={{marginTop:'15px'}}>
                            <Col xs={12} lg={6}>
                                <TopSelect onChange={this.onChangeNowyPojazd} value={this.state.nowypojazd} options={this.props.pojazdy}
                                           valueKey={'idPo'} labelKey={'pojazdInfo'} placeholder={'Szukaj po rejestracja marka model...'}
                                            valueRenderer={this.renderPojazdSelect} optionRenderer={this.renderPojazdSelect}
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                                <FormControl type={'number'} onChange={this.onChangeNowaZmiana} defaultValue={1} id={'inputNowaZmianaPojazd'}/>
                            </Col>
                            <Col xs={6} lg={4}>
                                <TopButtonAdd onClick={this.onClickDodajNowy} text={'Dodaj pojazd do ekipy'}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipa/components/PojazdyEkipaCompontent.js